import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { IrpCreateEditProvider } from './context/irp-create-edit-context';
import { IrpCreateEditComponent } from './irp-create-edit-component';

export function IrpCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <IrpCreateEditProvider>
                <IrpCreateEditComponent />
            </IrpCreateEditProvider>
        </BaseLayoutFactory>
    );
}
